import GizmodoLogo from '@components/icons/gimodoLogo';
import NewYorkTimesLogo from '@components/icons/newYorkTimesLogo';
import TechCrunchLogo from '@components/icons/techCrunchLogo';
import TheWashingtonPostLogo from '@components/icons/theWashingtonPostLogo';
import WiredLogo from '@components/icons/wiredLogo';
import { FeaturedByCompanyConfetti } from '@components/web-landingpage/ConfettiBackground';
import { BodyTextSmall } from '@components/web-landingpage/Texts';

export function FeaturedByCompaniesComponent() {
  return (
    <>
      <BodyTextSmall className="mt-6 w-full text-center text-product2-content-secondary">
        Featured in
      </BodyTextSmall>
      <div className="mt-6 flex w-full flex-wrap justify-center gap-6 lg:justify-between">
        <TechCrunchLogo className="flex max-h-5 items-start justify-center tabletLg:h-6" />
        <NewYorkTimesLogo className="flex max-h-5 items-start justify-center tabletLg:h-6" />
        <WiredLogo className="flex max-h-5 items-start justify-center tabletLg:h-6" />
        <GizmodoLogo className="flex max-h-5 items-start justify-center tabletLg:h-6" />
        <TheWashingtonPostLogo className="flex max-h-5 items-start justify-center tabletLg:h-6" />
      </div>
      <FeaturedByCompanyConfetti></FeaturedByCompanyConfetti>
    </>
  );
}

export default FeaturedByCompaniesComponent;
